import Konva from 'konva';

export class SceneManager extends Konva.Group {
  private _stage: Konva.Stage;

  private _currentScene: any;

  private _sceneCallbacks: any = {};

  constructor(stage: Konva.Stage, config?: Konva.GroupConfig) {
    super(config);
    this._stage = stage;
  }

  getScene(SceneCtor: any) {
    const scene = this.children?.find(
      (scene: any) => scene.constructor.sceneId === SceneCtor.sceneId
    );
    if (!scene) {
      throw new Error('No such scene!');
    }
    return scene;
  }

  hasScene(SceneCtor: any) {
    return (
      this.children?.findIndex((scene: any) => scene.constructor.sceneId === SceneCtor.sceneId) !==
      -1
    );
  }

  goto(SceneCtor: any, callbacks?: any) {
    if (this._currentScene?.constructor.sceneId === SceneCtor.sceneId) {
      return;
    }

    // Store callbacks for future scene creation
    if (callbacks) {
      this._sceneCallbacks = callbacks;
    }

    let scene;
    if (this.hasScene(SceneCtor)) {
      scene = this.getScene(SceneCtor);
    } else {
      scene = new SceneCtor(this._stage, this, this._sceneCallbacks);
      this.add(scene);
    }
    if (this._currentScene) {
      this._currentScene.hide();
    }
    this._currentScene = scene;
    scene.show();
  }
}
